import { render, staticRenderFns } from "./CarbonTransfer0.vue?vue&type=template&id=64184bc8&scoped=true&"
import script from "./CarbonTransfer0.vue?vue&type=script&lang=js&"
export * from "./CarbonTransfer0.vue?vue&type=script&lang=js&"
import style0 from "./CarbonTransfer0.vue?vue&type=style&index=0&id=64184bc8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64184bc8",
  null
  
)

export default component.exports